import { render, staticRenderFns } from "./OptimizeRoute.vue?vue&type=template&id=20fbe9fa"
import script from "./OptimizeRoute.vue?vue&type=script&lang=js"
export * from "./OptimizeRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports